import React from "react";
import "./ViewCareer.scss";
import logo from "assets/images/datagonomix.jpg";
import { Link } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import JobOpeningService from "Pages/AdministratorDashboard/APIServices/JopOpeningService";
import { getPostingSkills } from "Common/skillHelpers";
import JobSideDetail from "./JobSideDetail";
import InputFields from "./InputFields";
import { useLocation, useNavigate } from "react-router-dom";

function FinancialAnalyst() {
  const { handleShow, jobDetails, show } = JobOpeningService();
  const candidateId = sessionStorage.getItem("candidateId");
  const isLoggedIn = !!candidateId;
  const location = useLocation();
  const isApplied = location.state?.isApplied;
  const navigate = useNavigate();

  const renderHTML = (htmlContent) => {
    return { __html: htmlContent };
  };
  // Assign job details based on job nam
  return (
    <div className="wrapper d-flex flex-column min-vh-100 bg-light">
      <div className="body flex-grow-1 px-5">
        <div
          style={{
            marginTop: "50px",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          {/* LEFT SIDE */}
          <div style={{ display: "flex", alignItems: "center" }}>
            <img src={logo} alt="" height={"60px"} />
            &nbsp;&nbsp;&nbsp;
            <h4 className="logo"></h4>
          </div>

          {/* RIGHT SIDE */}
          {!isLoggedIn && (
            <Link
              to="/empsignIn"
              state={{ from: location.pathname }}
              style={{ marginRight: "10px" }}
            >
              <button className="btn btn-primary btn-sm">Login</button>
            </Link>
          )}
        </div>
        <div style={{ display: "flex", marginTop: "30px" }}>
          <div className="row">
            <div className="col-xl-8 mb-2">
              <div className="card" style={{ flex: "1", marginRight: "20px" }}>
                <div className="card-body">
                  <ul>
                    <Link className="back-link" to="/viewcareer">
                      <div className="backjob-opening">
                        <svg viewBox="0 0 8 7" width="8" height="7" className="back-icon">
                          <g fillRule="evenodd" stroke="none" strokeWidth="1">
                            <g>
                              <g transform="translate(-56 -101) translate(56 101)">
                                <path d="M3.4693 0 3.9985 1.2247 1.7463 3.5002 4 5.774 3.4697 7 0 3.5002z"></path>
                                <path d="M2 3H8V4H2z"></path>
                              </g>
                            </g>
                          </g>
                        </svg>
                        <span>Job Openings</span>
                      </div>
                    </Link>
                    {jobDetails && (
                      <div>
                        <>
                          <li style={{ fontSize: "medium" }}>
                            <h2 className="card-title heading-ViewCaree">{jobDetails.jobTitle}</h2>
                          </li>
                          <hr className="hr-viewcareer"></hr>
                        </>
                      </div>
                    )}
                    {show && (
                      <>
                        <div className="aboutus">
                          <div className="aboutus-i">
                            <div className="about-ii">
                              {jobDetails && (
                                <>
                                  <div className="aboutus-iii">
                                    <div
                                      dangerouslySetInnerHTML={renderHTML(
                                        jobDetails.jobDescription
                                      )}
                                    />
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                          <hr className="hr-viewcareer"></hr>
                        </div>
                        <div className="aboutus">
                          <div className="aboutus-i">
                            <div className="about-ii">
                              {jobDetails && (
                                <>
                                  <div className="aboutus-iii">
                                    <h4>Skills Required:</h4>
                                    <ul>
                                      {getPostingSkills(jobDetails).map((skill, index) => (
                                        <li key={index}>{skill}</li>
                                      ))}
                                    </ul>
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                          <hr className="hr-viewcareer"></hr>
                        </div>
                      </>
                    )}
                    {!show && (
                      <>
                        <p style={{ fontSize: "medium" }}>
                          <span style={{ fontWeight: "bold" }}>Apply for this Position</span>
                        </p>
                        <InputFields />
                      </>
                    )}
                  </ul>
                </div>
              </div>
            </div>
            <div className="col-xl-4">
              {jobDetails && (
                <>
                  <div className="card block" style={{ flex: "1", height: "565px" }}>
                    {/* Hide the Apply for This Job CTA while the inline
                        application form is open (show === false). Per
                        Mudassir: duplicate Apply + Submit was confusing. */}
                    {show && (
                      <div className="fab-Card fab-Card--sizeFull fab-Card--withoutBottomGradient">
                        <div style={{ padding: "32px 24px" }}>
                          {isApplied ? (
                            <div
                              style={{
                                padding: "10px 15px",
                                backgroundColor: "#d4edda",
                                color: "#155724",
                                borderRadius: "5px",
                                fontWeight: "bold",
                                textAlign: "center",
                              }}
                            >
                              Already Applied
                            </div>
                          ) : (
                            <button
                              className="jss-f143 css-8ef6qm"
                              tabIndex="0"
                              type="button"
                              disabled={!isLoggedIn}
                              title={!isLoggedIn ? "Please login to apply" : "Click to apply"}
                              style={{
                                cursor: !isLoggedIn ? "not-allowed" : "pointer",
                                opacity: !isLoggedIn ? 0.6 : 1,
                              }}
                              onClick={() => {
                                if (isLoggedIn) {
                                  handleShow();
                                } else {
                                  navigate("/empsignIn", {
                                    state: {
                                      from: location.pathname,
                                    },
                                  });
                                }
                              }}
                            >
                              <span className="jss-f149">Apply for This Job</span>
                            </button>
                          )}
                        </div>
                      </div>
                    )}
                    <JobSideDetail />
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FinancialAnalyst;
